<template>
  <div class="inputgroup-append">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'inputgroup-append'
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";
  .inputgroup-append {
    @include flex(flex,flex-start,center,row,nowrap);
  }
</style>



// WEBPACK FOOTER //
// src/components/input/InputgroupAppend.vue